/**
 * Builds an application/x-www-form-urlencoded query string without the
 * deprecated `querystring` npm package.
 *
 * @param params - Key/value map; `null`/`undefined` values are skipped.
 * @returns Encoded query string without a leading `?`.
 */
export function stringifyQuery(
  params: Record<
    string,
    string | number | boolean | ReadonlyArray<string | number> | null | undefined
  >
): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) {
      continue;
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        search.append(key, String(item));
      }
      continue;
    }
    search.set(key, String(value));
  }
  return search.toString();
}
